import { QUERY_KEYS } from "@/libraries/constant";
import { storageService } from "@/services";
import { infiniteQueryOptions } from "@tanstack/react-query";

export const getStoragesQueryOptions = () => {
	return infiniteQueryOptions({
		queryKey: [QUERY_KEYS.GET_STORAGES],
		queryFn: ({ pageParam }) => storageService.storages({ page: pageParam }),
		getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
		initialPageParam: 1,
	});
};
